export default __webpack_public_path__ + "static/media/080_finish_bad.last.a48e7e2e.webp";